import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Texture, Spritesheet } from "pixi.js";
export class MyWalletResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("MyWalletResourcePackage");
    }
    public get assets_views_my_wallet_particles_3_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/3.png");
    }
    public get assets_views_my_wallet_particles_3_2_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/3_2.png");
    }
    public get assets_views_my_wallet_particles_4_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/4.png");
    }
    public get assets_views_my_wallet_particles_4_2_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/4_2.png");
    }
    public get assets_views_my_wallet_particles_emitter_V5_2_json(): Object {
        return this.resource<Object>("assets/views/my_wallet/particles/emitter_V5_2.json");
    }
    public get assets_views_my_wallet_particles_emitter_V7_2_json(): Object {
        return this.resource<Object>("assets/views/my_wallet/particles/emitter_V7_2.json");
    }
    public get assets_views_my_wallet_particles_particle_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/particle.png");
    }
    public get assets_views_my_wallet_particles_particle_V2_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/particles/particle_V2.png");
    }
    public get assets_views_my_wallet_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/my_wallet/ui/ui_1x.atlas.json");
    }
    public get assets_views_my_wallet_ui_vertical_light_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["vertical_light.png"];
    }
    public get assets_views_my_wallet_ui_wallet_header_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["wallet_header.png"];
    }
    public get assets_views_my_wallet_ui_wallet_footer_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["wallet_footer.png"];
    }
    public get assets_views_my_wallet_ui_mon_send_frame_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["mon_send_frame.png"];
    }
    public get assets_views_my_wallet_ui_mon_receive_frame_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["mon_receive_frame.png"];
    }
    public get assets_views_my_wallet_ui_tokens_frame_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["tokens_frame.png"];
    }
    public get assets_views_my_wallet_ui_wallet_glass_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["wallet_glass.png"];
    }
    public get assets_views_my_wallet_ui_tokens_separator_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["tokens_separator.png"];
    }
    public get assets_views_my_wallet_ui_tooltip_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["tooltip.png"];
    }
    public get assets_views_my_wallet_ui_scroll_glass_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["scroll_glass.png"];
    }
    public get assets_views_my_wallet_ui_input_field_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["input_field.png"];
    }
    public get assets_views_my_wallet_ui_network_tooltip_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["network_tooltip.png"];
    }
    public get assets_views_my_wallet_ui_line_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["line.png"];
    }
    public get assets_views_my_wallet_ui_text_field_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["text_field.png"];
    }
    public get assets_views_my_wallet_ui_horizontal_light_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["horizontal_light.png"];
    }
    public get assets_views_my_wallet_ui_adress_placeholder_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["adress_placeholder.png"];
    }
    public get assets_views_my_wallet_ui_dice_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["dice.png"];
    }
    public get assets_views_my_wallet_ui_metamask_glow_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["metamask_glow.png"];
    }
    public get assets_views_my_wallet_ui_wallet_glow_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["wallet_glow.png"];
    }
    public get assets_views_my_wallet_ui_mon_token_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["mon_token_icon.png"];
    }
    public get assets_views_my_wallet_ui_usdc_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["usdc_icon.png"];
    }
    public get assets_views_my_wallet_ui_building_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["building_icon.png"];
    }
    public get assets_views_my_wallet_ui_dice_roll_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["dice_roll_icon.png"];
    }
    public get assets_views_my_wallet_ui_piggy_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["piggy_icon.png"];
    }
    public get assets_views_my_wallet_ui_tokens_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["tokens_icon.png"];
    }
    public get assets_views_my_wallet_ui_add_wallet_glass_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["add_wallet_glass.png"];
    }
    public get assets_views_my_wallet_ui_copy_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["copy_icon.png"];
    }
    public get assets_views_my_wallet_ui_copy_address_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["copy_address_icon.png"];
    }
    public get assets_views_my_wallet_ui_other_network_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["other_network_icon.png"];
    }
    public get assets_views_my_wallet_ui_disconnect_icon_png(): Texture {
        return this.assets_views_my_wallet_ui_ui_1x_atlas_json.textures["disconnect_icon.png"];
    }
    public get assets_views_my_wallet_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/my_wallet/ui/ui_1x.atlas.png");
    }
}

